<template>
  <div class="application" id="unsupported-browser-page">
    <el-container>
      <el-header style="height: 86px;background-color: #151515;">
        <LoginPageHeader />
      </el-header>
      <div style="flex: 1 0 auto; text-align: center; margin-top: 40px">
        <div>
          <h1 style="font-size: 42px; margin: 6px;">Unsupported browser</h1>
        </div>
        <p class="mb-2 mt-4 unsupported-text">
          You seem to be using a web browser or mobile device we don't support.
        </p>
        <p class="mb-2 mt-4 unsupported-text">
          Download the latest version of one of these browsers on your
          desktop/laptop computer to visit this site.
        </p>
        <p
          class="mb-2 mt-4"
          style="background-color: #ecf8ff; padding: 15px; font-size: 15px"
        >
          Already using one of these browsers? Try checking for updates!
        </p>
        <p class="mb-2 mt-4 unsupported-text">
          <LearnMoreHelpIconLink
            url="https://mementoyearbooks.freshdesk.com/support/solutions/articles/158000324313"
            :pxFontSize="15"
            linkText="View detailed requirements"
          ></LearnMoreHelpIconLink>
        </p>
        <div class="container" style="margin-top: 50px">
          <div class="row">
            <div class="col-md-4 mb-3">
              <a href="https://www.google.com/chrome/" target="_blank">
                <img
                  src="../../assets/images/browsers/chrome.png"
                  width="200"
                  class="mb-4"
                />
              </a>
              <div>
                <a href="https://www.google.com/chrome/" target="_blank"
                  >Google Chrome</a
                >
              </div>
              <div>Version 64+</div>
            </div>
            <div class="col-md-4 mb-3">
              <a href="https://www.mozilla.org/en-US/firefox/" target="_blank">
                <img
                  src="../../assets/images/browsers/firefox.png"
                  width="200"
                  class="mb-4"
                />
              </a>
              <div>
                <a href="https://www.mozilla.org/en-US/firefox/" target="_blank"
                  >Mozilla Firefox</a
                >
              </div>
              <div>Version 62+</div>
            </div>
            <div class="col-md-4 mb-3" v-if="_isMac">
              <a href="https://support.apple.com/en-ca/safari" target="_blank">
                <img
                  src="../../assets/images/browsers/safari.png"
                  width="200"
                  class="mb-4"
                />
              </a>
              <div>
                <a href="https://support.apple.com/en-ca/safari" target="_blank"
                  >Safari</a
                >
              </div>
              <div>Version 11.1.2+</div>
            </div>
          </div>
        </div>
      </div>
      <el-footer height="40px">
        <LoginPageFooter :darkText="true" />
      </el-footer>
    </el-container>
  </div>
</template>

<script type="text/babel">
import LoginPageFooter from "@/components/layout/Footer.vue";
import LoginPageHeader from "@/components/layout/Header.vue";
import LearnMoreHelpIconLink from "@/components/help/LearnMoreHelpIconLink";
import { isMac } from "@/util";
export default {
  name: "UnsupportedBrowserPage",
  components: {
    LoginPageHeader,
    LoginPageFooter,
    LearnMoreHelpIconLink
  },
  data() {
    return {};
  },
  computed: {
    _isMac() {
      return isMac();
    }
  }
};
</script>
<style>
@import "../../styles/css/login.css";
@import "../../styles/css/lib/bootstrap/bootstrap-grid.css";
.unsupported-text {
  font-size: 15px;
  margin: 6px;
}
</style>
